import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ProductsPage from "@/pages/ProductsPage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import ContactPage from "@/pages/ContactPage";
import StorePage from "@/store/StorePage";
import { CartProvider } from "@/store/CartContext";
import { AuthProvider } from "@/admin/AuthContext";
import ProtectedRoute from "@/admin/ProtectedRoute";
import AdminLoginPage from "@/admin/AdminLoginPage";
import AdminDashboard from "@/admin/AdminDashboard";

function PublicLayout({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  if (isAdmin) return children;
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function AppRoutes() {
  return (
    <PublicLayout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/sobre" element={<AboutPage />} />
        <Route path="/produtos" element={<ProductsPage />} />
        <Route path="/como-funciona" element={<HowItWorksPage />} />
        <Route path="/contacto" element={<ContactPage />} />
        <Route path="/loja" element={<StorePage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </PublicLayout>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#F3F1EB]">
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <CartProvider>
            <AppRoutes />
            <Toaster position="top-center" richColors />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
